// Status and per-answer flags of a questionnaire, judged against the client's own baseline (see
// baseline.js). Port of msb-mobile src/helpers/readiness/status.ts.

// "learning" while the baseline is still being built. Edges of the range count as "within".
export const getReadinessStatus = (total, baseline) => {
  if (!baseline?.ready || !baseline.total) return "learning";
  if (total < baseline.total.lo) return "below";
  if (total > baseline.total.hi) return "above";
  return "within";
};
/**
 * Gets the answer flag for a value.
 * @param {*} value
 * @param {*} range
 * @returns
 */
export const getAnswerFlag = (value, range) => {
  if (!range) return null;
  if (value < range.lo) return "lower";
  if (value > range.hi) return "higher";
  return null;
};
